import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getApps } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBuwYjfPvw4Nf6Mvj_erR6ifSxI3FIaPsM",
  authDomain: "cuetiansaga.firebaseapp.com",
  projectId: "cuetiansaga",
  storageBucket: "cuetiansaga.appspot.com",
  messagingSenderId: "885751404929",
  appId: "1:885751404929:web:6051cac4a9385cd2a07080",
  measurementId: "G-NMRZ9PCS5B"
};

const firebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const db = getFirestore(firebaseApp);